import { Button, Flex, Image, Input, Text } from "@chakra-ui/react";
import React, { useEffect, useRef, useState } from "react";
import Modal from "react-modal";
import Address from "../../components/Address";
import { AdminMenuBar } from "../../components/admin/AdminMenuBar";
import CertificationCard from "../../components/CertificationAdminCard";
import PreviewImage from "../../images/img.png";
import { checkSession } from "../../services/Admin";
import {
  getCertification,
  postCertification,
} from "../../services/CertificationAPI";
import "../ContentFrame.css";
import "../Main.css";

export const AdminCertification = () => {
  Modal.setAppElement("#root");
  let [cardList, setCardList] = useState([]);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const [value, setValue] = useState(""); // 인증서명
  const handleChange = (event) => setValue(event.target.value);

  const [file, setFile] = useState(null); // 파일 임시 저장 변수
  const [imgBase64, setImgBase64] = useState(null); // 파일 base64

  const [updateState, setUpdateState] = useState();

  const fileChange = (event) => {
    setFile(event.target.files[0]);

    setImgBase64([]);

    for (var i = 0; i < event.target.files.length; i++) {
      if (event.target.files[i]) {
        let reader = new FileReader();
        reader.readAsDataURL(event.target.files[i]); // 1. 파일을 읽어 버퍼에 저장.
        // 파일 상태 업데이트
        reader.onloadend = () => {
          // 2. 읽기가 완료되면 아래코드가 실행.
          const base64 = reader.result;
          if (base64) {
            // 문자 형태로 저장
            var base64Sub = base64.toString();
            // 배열 state 업데이트
            setImgBase64((imgBase64) => [...imgBase64, base64Sub]);
          }
        };
      }
    }
  };

  useEffect(() => {
    checkSession();
    let cards = [];
    getCertification().then((certifications) => {
      certifications.map((certification) => {
        cards.push(
          <CertificationCard
            key={certification["id"]}
            id={certification["id"]}
            image={certification["imageUrl"]}
            title={certification["name"]}
            setUpdateState={setUpdateState}
          />
        );
        setCardList(cards);
      });
    });
  }, []);

  useEffect(() => {
    let cards = [];
    getCertification().then((certifications) => {
      certifications.map((certification) => {
        cards.push(
          <CertificationCard
            key={certification["id"]}
            id={certification["id"]}
            image={certification["imageUrl"]}
            title={certification["name"]}
            setUpdateState={setUpdateState}
          />
        );
        setCardList(cards);
      });
    });
  }, [updateState]);

  const inputRef = useRef(null);

  const handleClick = () => {
    inputRef.current.click();
  };

  const postFileClick = () => {
    postFile(file);
  };

  const postFile = (file) => {
    postCertification(file, value);
    alert("인증서가 추가되었습니다!");
    setIsModalOpen(false);
    setUpdateState(Math.random());
  };

  const clearState = () => {
    setValue(null);
    setImgBase64(null);
    setFile(null);
    setIsModalOpen(false);
  };

  const confirmForm = () => {
    if (
      (value === "" || value === null || isSpaceWord(value)) &&
      imgBase64 === null
    ) {
      alert("인증서명 입력 및 사진 업로드를 완료해주세요!");
    } else if (value === "" || value === null || isSpaceWord(value)) {
      alert("인증서명을 입력해주세요! 공백은 인정되지 않습니다.");
    } else if (imgBase64 === null) {
      alert("인증서 사진을 업로드 해주세요!");
    } else {
      postFileClick();
    }
    setValue("");
    setImgBase64("");
    setFile("");
  };

  const isSpaceWord = (word) => {
    // 공백으로만 이루어진 경우 체크
    const removedWord = word.replace(/\s/g, "");
    if (removedWord === "") {
      return true;
    }
    return false;
  };

  return (
    <div className="main_container">
      <AdminMenuBar selected_page={2} />
      <div className="common_frame_container">
        <div className="common_content_container">
          <div style={{ width: "100%", height: "100px" }}></div>
          <span className="page_title">인증서</span>
          <Flex maxW="100%" marginY="10px" justifyContent="right">
            <Text mt="5px" mr="20px" as="b" fontSize="3xl">
              인증서 편집 및 삭제를 원하시면 해당 인증서를 클릭하십시오.
            </Text>
            <Button
              cursor="pointer"
              colorScheme="blue"
              fontSize="3xl"
              px="10px"
              py="20px"
              onClick={() => setIsModalOpen(true)}
            >
              인증서 추가
            </Button>
          </Flex>
          <div className="certificate_grid_container">{cardList}</div>
          <div style={{ width: "100%", height: "100px" }}></div>
        </div>
      </div>

      <Modal
        isOpen={isModalOpen}
        style={{
          content: {
            width: "400px",
            height: "570px",
            margin: "auto",
            marginTop: "80px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          },
        }}
      >
        <Flex alignItems="center" direction="column">
          <Text fontSize="5xl" as="b" mb="30px" mt="10px">
            인증서 추가
          </Text>

          <Flex alignContent="center" mb="10px" mt="10px">
            <Text fontSize="2xl" mt="-3px" width="100px">
              인증서명:
            </Text>
            <Input
              htmlSize={15}
              value={value}
              onChange={handleChange}
              size="sm"
            />
          </Flex>
          <Image
            mt="10px"
            mb="10px"
            height="250px"
            src={imgBase64 ? imgBase64 : PreviewImage}
            alt="미리보기"
          />
          <Flex mb="8px" mt="2px">
            <Input
              width="150px"
              defaultValue={file ? file.name : ""}
              readOnly
            />
            <Button
              ml="5px"
              width="80px"
              fontSize="xl"
              height="25px"
              size="md"
              colorScheme="red"
              onClick={handleClick}
            >
              파일 선택
            </Button>
            <input
              style={{ display: "none" }}
              ref={inputRef}
              type="file"
              accept="image/*"
              onChange={fileChange}
            />
          </Flex>

          <Flex mt="30px" mb="10px">
            <Button
              fontSize="3xl"
              px="10px"
              py="17px"
              colorScheme="red"
              mr={3}
              onClick={() => clearState()}
            >
              닫기
            </Button>
            <Button
              fontSize="3xl"
              px="10px"
              py="17px"
              colorScheme="gray"
              onClick={confirmForm}
            >
              추가
            </Button>
          </Flex>
        </Flex>
      </Modal>

      <Address />
    </div>
  );
};
